export default "__VITE_ASSET__BaUNBhd5__"